import axios from "axios";
import { createStore, createEffect } from "effector";
import { getCustomUserAgent, getCustomUserAgentASB } from "../../../common/customUserAgent"
import { unpackServerData } from "../../../common/functions";
import { getUuidAndSession } from "../../../common/localStorage";

export interface IQueryChargeRents {
  accountId: number,
  id: string
}
export const $currChargeRents = createStore<any[]>([])
 
export const queryCurrChargeRents = createEffect<IQueryChargeRents, any>();


$currChargeRents.on(queryCurrChargeRents.doneData, (_, val) => val);

queryCurrChargeRents.use((params: IQueryChargeRents) =>
  fetch("https://izba.kras-abs.ru/api/v3/charge/rent",  
  {
    method: "POST",
    body: JSON.stringify({
      ...getUuidAndSession(),
      "accountId": params.accountId,
      "chargePeriodId": params.id
    }),
    headers: {
      "accept": "*/*",
      "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      "Custom-User-Agent": getCustomUserAgent()
    },
  })
  .then((res) => res.json())
    .then(async (res) => {
      // console.log('resres', res)
      if(res) {
        const charges = res.charges as IChargeRents[];
        const pdfLink = await fetch("https://izba.kras-abs.ru/api/v3/charge/pdfAddress", {
          method: "POST",
          body: JSON.stringify({
            ...getUuidAndSession(),
            "accountId": params.accountId,
            "chargePeriodId": params.id
          }),
          headers: {
            "accept": "*/*",
            "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
            "Custom-User-Agent": getCustomUserAgent()
          },
        }).then((res) => res.json())
        if (getCustomUserAgent() === getCustomUserAgentASB()) {
          const result = []
          const prePaidArray: IChargeRents[] = []
          const postPaidArray: IChargeRents[] = []
          charges.forEach((el) => {
            if (el.serviceNote === 'prePaid')
              prePaidArray.push(el)
            else
              postPaidArray.push(el)
          }
          )

          const arrayOfArrays = [prePaidArray, postPaidArray];
          arrayOfArrays.forEach(element => {
            const typeNames: string[] = []
            element.forEach((el) => {
              typeNames.push(el.typeName)
            }
            )
            const uniqueTypeNames = Array.from(new Set(typeNames));
      
            const billsObj = uniqueTypeNames.map((el) => {
              return {
                typeOfBill: el,
                services: [] as any
              }
            })
            element.forEach((el) => {
              for (let i = 0; i < billsObj.length; i++) {
                if (el.typeName === billsObj[i].typeOfBill) billsObj[i].services.push(el)
            }
          })
          result.push(billsObj)
        });
        result.push({ pdfLink: pdfLink })
        // console.log('result', result)
        return result
      }

      const typeNames: string[] = []
      charges.forEach((el) => {
        typeNames.push(el.typeName)
      }
      )
      const uniqueTypeNames = Array.from(new Set(typeNames));

      const billsObj = uniqueTypeNames.map((el) => {
        return {
          typeOfBill: el,
          services: [] as any
        }
      })
      charges.forEach((el) => {
        for (let i = 0; i < billsObj.length; i++) {
          if (el.typeName === billsObj[i].typeOfBill) billsObj[i].services.push(el)
        }
      })//@ts-ignore
      billsObj.push({ pdfLink: pdfLink })
      console.log(billsObj)
      return billsObj
      }
      else return null;
    }) 
    .catch((err) => {
      console.log("err_c:", err)
      return null
    })
);

export interface IChargeRents {
  accruedBasic: any,
  accruedOver: any,
  accruedPublic: number,
  date: string,
  recalculation: number,
  refund: number,
  serviceId: number,
  serviceName: string,
  serviceNote: string,
  serviceTypesId: number,
  toPay: number,
  totalByMonthId: number,
  typeName: string,
  unicId: string,
  unitId: number,
  unitName: string,
  unitPrice: number,
  volumePersonal: any,
  volumePublic: string,
  volumeTotal: string
}

export const asyncQueryChargeRents = async (accountId: number, periodId: string) => {
  const response = await fetch("https://izba.kras-abs.ru/api/v2/getRentNew", {//оно используется? Кажется нет
    method: "POST",
    body: JSON.stringify({
      ...getUuidAndSession(),
      "accountId": accountId,
      "periodId": periodId
    }),
    headers: {
      "accept": "*/*",
      "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      "Custom-User-Agent": getCustomUserAgent()
    },
  });

  if (!response.ok) throw new Error('Не удалось загрузить историю');
  console.log("rents:", response)
  const json = await response.json();
  console.log("rents:", json)
  return json;
}


export interface IQueryAccountPeriodRents {
  accountId: number,
  periodId: string,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setFailMsg: React.Dispatch<React.SetStateAction<string>>;
  setRents: React.Dispatch<React.SetStateAction<IChargeRents[]>>;
}

export const queryAccountPeriodRents = createEffect<IQueryAccountPeriodRents, void>();


queryAccountPeriodRents.use(({ accountId, periodId, setLoading, setFailMsg, setRents }) =>
  axios.post("https://izba.kras-abs.ru/api/v2/getRentNew", {//оно используется? Кажется нет
    ...getUuidAndSession(),
    accountId: accountId,
    periodId: periodId
  }, {
    headers: {
      "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      "Custom-User-Agent": getCustomUserAgent(),
    }
  }).then((resp) => {
    console.log(resp)
    let data = unpackServerData(resp.data, "charges")
    console.log("queryAccountPeriodRents:success333:", data.data)
    console.log(data)
    if (data.failMsg == "") {
      setRents(data.data as IChargeRents[])
    } else {
      setFailMsg(data.failMsg)
    }
    setLoading(false)
  }).catch(e => {
    let msg = e.message
    console.log("queryAccountPeriodRents:error1:", e)
    if (e.response && e.response.data) {
      console.log("queryAccountPeriodRents:error1:", e.response.data)
      let data = unpackServerData(e.response.data)
      if (data.failMsg != "") {
        msg = data.failMsg
      }
    }
    setFailMsg(msg)
    setRents([])
    setLoading(false)
  })
);